import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/admin/delete-partners/`;
export const Csrf = () => `/api/v3/admin/token/`;
export declare const QueryKey: never;
export type Payload = Pick<Models.Partners.Partner, 'id'>;
export type Response = void;
